import {
  DBxEvent
} from "cartovista";
import ResultsList from "cartovistaExtend/panels/Results/ResultsList";
import FindRoutesResultItem from "cartovistaExtend/panels/na/FindRoutesResultItem";

    export default class FindRoutesResultsList extends ResultsList {
      constructor($container, layer, dataTable, accordion) {
        super($container, layer, dataTable, accordion);
      };

    addResult(features, name, directions, stops) {
        this.increment += 1;
        this.resultItems.push(new FindRoutesResultItem(this, features, name, directions, stops));
        this.generateUI();
        this.dispatchEvent(new DBxEvent("ResultsList_resultAdded"));
    };

    removeResult(resultItem) {
        super.removeResult(resultItem);
        this.stopsLayer.removeFeatures(resultItem.stops);
        this.stopsDataTable.removeDataRows(_.map(resultItem.stops, "id"))
        this.directionsDataTable.removeDataRows(_.map(resultItem.directions, "feature.id"))
    };

    zoomOnFeatures(features) {
        this._mapController.zoomOnFeatures(features, (features[0].geometryType == "POLYLINE" ? this.layer : this.stopsLayer), null, false);
    };
}
